<template>
    <el-tooltip class="item" effect="dark" :content="content" placement="top">
        <span>
            <slot></slot>
            <span class="el-icon-question ml4"></span>
        </span>
    </el-tooltip>
</template>

<script>
    export default {
        name: "MiniToolTips",
        props:{
            content:String,
        },
    }
</script>

<style scoped>

</style>
